import Radium from "radium";
import React, { Component } from "react";
import { connect } from "react-redux";
import { routeActions } from "redux-simple-router";
import { withRouter } from "react-router";
import "bootstrap/js/dropdown";
import { semanticColors, greyScaleColors } from "../../Globals/styles";
import { httpGet, httpPut } from "../../Util/http";

import auth from "../../Login/authService";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      lastLocation: undefined,
    };
  }
  logout() {
    auth.logout();
    if (window.connection) window.connection.stop();
    localStorage.clear();
  }
  componentDidMount() {
    var newTitle = process.env.REACT_APP_title;
    if (document.title != newTitle) {
      document.title = newTitle;
    }
    if (auth.loggedIn()) {
      if (auth.getProfile().email !== "pladsen@ceas.dk") {
        var _url = process.env.REACT_APP_webApiEndPoint + `api/user/notif2`;
        httpGet(_url)
          .then((resp) => resp.json())
          .then((resp) => {
            if (resp.disabled) {
              alert("Din bruger er blevet blokeret!");
              auth.logout();
              window.location.reload();
            }
            this.setState({
              email: resp.email,
            });
          });
      }

      const urlas = localStorage.getItem("lastLocation");
      if (
        urlas !== undefined &&
        urlas !== null &&
        urlas.startsWith("http") &&
        window.location.href !== urlas
      ) {
        this.setState({
          lastLocation: urlas,
        });
      }
    }
  }
  isCurrentLocationActivityOverview = () => {
    var location = this.props.location.pathname.split("/");
    return location[2] === "sag" && location.length === 4;
  };
  shouldGoToIndex = () => {
    var location = this.props.location.pathname.split("/");
    return (
      (location[1] === "tilbud" && location.length === 2) ||
      (location[1] === "afdeling" && location.length === 3)
    );
  };
  isCurrentLocationWeekOverview = () => {
    var location = this.props.location.pathname.split("/");
    return (
      location[2] === "sag" &&
      location.length === 5 &&
      location[4] === "ugeoversigt"
    );
  };
  isCurrentLocationDepartment = () => {
    var location = this.props.location.pathname.split("/");
    return location[1] === "";
  };
  getEditProjectURL = () => {
    var location = this.props.location.pathname.split("/");
    return "/tilbud/sag/" + location[3] + "/rediger";
  };
  isTilbud = () => {
    var location = this.props.location.pathname.split("/");
    return location[1] === "tilbud" || location[0] === "tilbud";
  };
  getBackAction = () => {
    if (this.isCurrentLocationActivityOverview()) {
      return routeActions.push("/tilbud");
    } else if (this.shouldGoToIndex()) {
      return routeActions.push("/");
    } else {
      return routeActions.goBack();
    }
  };
  render() {
    const { title, showBackBtn, dispatch } = this.props;
    const user = auth.getProfile();
    return (
      <nav className="navbar" style={styles.navbar}>
        <div style={styles.fixNavbar}>
          {this.isCurrentLocationDepartment() && this.state.lastLocation ? (
            <div
              key="backBtn"
              style={styles.restore}
              onClick={() => {
                window.location.href = this.state.lastLocation;
              }}
            >
              <button className="btn btn-warning">
                <i className="fa fa-refresh"></i> Fortsæt, hvor du slap
              </button>
            </div>
          ) : null}
          <div
            style={[
              (!showBackBtn || user.email === "pladsen@ceas.dk") &&
                styles.hidden,
            ]}
          >
            <div
              className="waves-icon"
              key="backBtn"
              style={styles.backBtn}
              onClick={() => dispatch(this.getBackAction())}
            >
              <i className="fa fa-arrow-left"></i>
            </div>
            <div style={styles.separator}></div>
          </div>
          <h1 style={styles.title}>{title}</h1>
          {(this.isCurrentLocationActivityOverview() ||
            this.isCurrentLocationWeekOverview()) &&
          user.role !== "Formand" ? (
            <i
              style={styles.editProjectIcon}
              className="fa fa-cogs waves-icon"
              aria-hidden="true"
              onClick={() =>
                this.props.dispatch(routeActions.push(this.getEditProjectURL()))
              }
            ></i>
          ) : null}

          {this.isCurrentLocationDepartment() ? (
            <i
              style={styles.editProjectIcon}
              className={
                this.state.email == ""
                  ? "fa fa-bell waves-icon"
                  : "fa fa-bell-o waves-icon"
              }
              aria-hidden="true"
              onClick={() => {
                var person = prompt(
                  "Et nyt login system er på vej.\nVi har brug for din email\nIndtast din email-adresse her",
                  this.state.email
                );
                if (person == null) {
                } else {
                  var _url =
                    process.env.REACT_APP_webApiEndPoint +
                    `api/user/update?email=${person}`;
                  httpPut(_url).then(() => {
                    this.setState({
                      email: person,
                    });
                  });
                }
              }}
            ></i>
          ) : null}

          <div style={styles.dropdown}>
            <div className="btn-group dropdown">
              <button
                style={styles.dropBtn}
                className="dropdown-toggle waves-btn"
                id="dropdownMenu1"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <div style={styles.fullName}>{user.name}</div>
                <i style={styles.i} className="fa fa-chevron-down"></i>
              </button>
              <ul
                style={styles.ul}
                className="dropdown-menu"
                aria-labelledby="dropdownMenu1"
              >
                {user.role !== "Formand" ? (
                  <li
                    key="li4"
                    className="waves-btn"
                    onClick={() => {
                      this.props.dispatch(routeActions.push("/lon"));
                    }}
                    style={styles.li}
                  >
                    Løn
                  </li>
                ) : null}
                {user.role !== "Formand" ? (
                  <li
                    key="li6"
                    className="waves-btn"
                    onClick={() => {
                      this.props.dispatch(routeActions.push("/prislister"));
                    }}
                    style={styles.li}
                  >
                    Prislister
                  </li>
                ) : null}
                {user.role !== "Formand" ? (
                  <li
                    key="li7"
                    className="waves-btn"
                    onClick={() => {
                      this.props.dispatch(routeActions.push("/apv"));
                    }}
                    style={styles.li}
                  >
                    Generelle APV'er
                  </li>
                ) : null}
                <li
                  key="li5"
                  className="waves-btn"
                  onClick={() => {
                    this.props.dispatch(routeActions.push("/materiel"));
                  }}
                  style={styles.li}
                >
                  {"Materiel & Materialer"}
                </li>
                {user.role !== "Formand" ? (
                  <li
                    key="li2a5"
                    className="waves-btn"
                    onClick={() => {
                      this.props.dispatch(routeActions.push("/users"));
                    }}
                    style={styles.li}
                  >
                    {"Brugere"}
                  </li>
                ) : null}
                {user.role !== "Formand" ? (
                  <li
                    key="li2a25"
                    className="waves-btn"
                    onClick={() => {
                      this.props.dispatch(routeActions.push("/projects"));
                    }}
                    style={styles.li}
                  >
                    {"Sager"}
                  </li>
                ) : null}
                {user.role !== "Formand" ? (
                  <li
                    key="li2a2225"
                    className="waves-btn"
                    onClick={() => {
                      this.props.dispatch(routeActions.push("/clients"));
                    }}
                    style={styles.li}
                  >
                    {"Bygherre"}
                  </li>
                ) : null}

                <li
                  key="lsdasdai2"
                  className="waves-btn"
                  onClick={() => {
                    this.logout();
                    this.props.dispatch(routeActions.push("/login"));
                  }}
                  style={{
                    borderRadius: "0px",
                    textAlign: "left",
                    display: "block",
                    cursor: "pointer",
                    padding: "1px",
                    marginTop: "25px",
                    borderTop: "1px solid lightgray",
                    textAlign: "center",
                    padding: 10,
                  }}
                >
                  Log ud
                </li>
                <li
                  key="li2212131221"
                  style={{
                    borderRadius: "0px",
                    textAlign: "left",
                    paddingTop: "12px",
                    color: "grey",
                    borderTop: "1px solid lightgray",
                    textAlign: "center",
                  }}
                >
                  v. 2.0.0
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

var styles = {
  navbar: {
    backgroundColor: semanticColors.default,
    borderRadius: "0px",
    "@media print": {
      display: "none",
    },
  },
  fixNavbar: {
    "@media (min-width: 1200px)": {
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: "1170px",
      width: "100%",
    },
  },
  dropdown: {
    position: "absolute",
    top: "5px",
    right: "0px",
  },
  i: {
    position: "absolute",
    right: "20px",
    lineHeight: "25px",
  },
  separator: {
    position: "absolute",
    top: "5px",
    left: "43px",
    height: "40px",
    borderLeft: "1px solid " + semanticColors.mainBackground,
    borderRadius: "2px",
  },
  backBtn: {
    color: semanticColors.text,
    borderRadius: "50%",
    fontSize: "20px",
    textAlign: "center",
    position: "absolute",
    zIndex: "2",
    top: "7px",
    left: "0px",
    height: "36px",
    width: "36px",
    lineHeight: "36px",
  },
  restore: {
    color: semanticColors.text,
    fontSize: "20px",
    textAlign: "center",
    position: "absolute",
    zIndex: "2",
    top: "7px",
    left: "0px",
    height: "36px",
    width: "200px",
    lineHeight: "36px",
  },
  title: {
    textAlign: "center",
    fontSize: "18px",
    height: "40px",
    lineHeight: "50px",
    "@media (min-width: 320px) and (max-width: 480px)": {
      marginLeft: "16px",
      textAlign: "start",
    },
  },
  dropBtn: {
    backgroundColor: semanticColors.default,
    cursor: "pointer",
    width: "190px",
    border: "none",
    borderRadius: "2px",
    padding: "6px 12px",
    height: "35px",
    lineHeight: "25px",
    textAlign: "left",
  },
  fullName: {
    width: "140px",
    display: "inline-block",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  ul: {
    width: "233px",
    padding: "4px",
  },
  li: {
    height: "26px",
    lineHeight: "26px",
    borderRadius: "0px",
    textAlign: "left",
    display: "block",
    cursor: "pointer",
    padding: "3px",
    ":hover": {
      backgroundColor: semanticColors.infoLighter,
    },
  },
  hidden: {
    visibility: "hidden",
  },
  editProjectIcon: {
    position: "absolute",
    top: "0",
    right: "190px",
    lineHeight: "50px",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: "1",
    color: greyScaleColors.grey,
  },
};

export const selectprops = (state) => {
  return {
    ...state.navbarReducer,
    router: state.routing,
  };
};

var n = Radium(Navbar);

export default withRouter(connect(selectprops)(n));



// WEBPACK FOOTER //
// ./src/App/MainClient/Navbar/index.jsx